/* import __COLOCATED_TEMPLATE__ from './special-notice.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();